(function () {
  'use strict';

  function getParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function safeJsonFromScript(selector) {
    const el = document.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '');
    } catch (e) {
      return null;
    }
  }

  function normalizeMatch(s) {
    return String(s || '').trim().toLowerCase();
  }

  function parseMediumList(raw) {
    const s = String(raw || '').trim();
    if (!s) return [];
    return s
      .split(/[,\n\r\t ]+/)
      .map(function (p) {
        return normalizeMatch(p);
      })
      .filter(Boolean);
  }

  function mediumMatches(required, actual) {
    const req = normalizeMatch(required);
    if (!req) return true;
    return req === normalizeMatch(actual);
  }

  function translateOccasion(ctx, adgroup) {
    const map = (ctx && ctx.i18n && ctx.i18n.occasions) || {};
    const key = String(adgroup || '').trim().toLowerCase();
    return map[key] || adgroup;
  }

  function applyTemplate(template, values) {
    return String(template || '').replace(/__([A-Z]+)__/g, function (_, token) {
      const key = token.toLowerCase();
      if (Object.prototype.hasOwnProperty.call(values, key)) return values[key];
      return '';
    });
  }

  function formatTitle(ctx) {
    const town = String(ctx.town || '').trim();
    const initial = String(ctx.initial || '').trim();
    const adgroup = String(ctx.adgroup || '').trim();
    const i18n = (ctx && ctx.i18n) || {};
    if (!town) return '';
    if (adgroup) {
      const occasion = translateOccasion(ctx, adgroup);
      return applyTemplate(i18n.titleWithOccasion, {
        town: town,
        occasion: occasion,
        initial: initial
      });
    }
    return applyTemplate(i18n.title, { town: town, initial: initial });
  }

  function formatDeliveryText(ctx) {
    const adgroup = String(ctx.adgroup || '').trim();
    const i18n = (ctx && ctx.i18n) || {};
    if (!adgroup) return '';
    const occasion = translateOccasion(ctx, adgroup);
    return applyTemplate(i18n.occasionDelivery, { occasion: occasion });
  }

  function equalizeTileWidths(root) {
    if (!root || !root.querySelectorAll) return;
    const wrappers = root.querySelectorAll('.local-florist-sub-slider--tile');
    wrappers.forEach(function (wrapper) {
      const items = wrapper.querySelectorAll('.utm-collection-slider-item');
      if (!items.length) return;

      wrapper.style.setProperty('--lf-equal-tile-width', 'auto');

      let maxWidth = 0;
      items.forEach(function (item) {
        const link = item.querySelector('.utm-collection-slider-link');
        if (!link) return;
        const w = Math.ceil(link.scrollWidth);
        if (w > maxWidth) maxWidth = w;
      });

      if (maxWidth > 0) {
        wrapper.style.setProperty('--lf-equal-tile-width', maxWidth + 'px');
      }
    });
  }

  function setupDefaultSliderGridSwap(container) {
    const slider = container.querySelector('[data-local-florist-slider="default"]');
    if (!slider) return;

    const links = slider.querySelectorAll('.utm-collection-slider-link[data-local-florist-grid-target]');
    if (!links.length) return;

    const baseGridId = 'local-florist-grid-default';

    function clearActive() {
      links.forEach(function (lnk) {
        lnk.classList.remove('is-active');
      });
    }

    function setActive(link) {
      clearActive();
      link.classList.add('is-active');
    }

    function showGrid(targetId) {
      const allGrids = container.querySelectorAll('[id^="local-florist-grid-default"]');
      allGrids.forEach(function (grid) {
        grid.hidden = grid.id !== targetId;
      });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (evt) {
        evt.preventDefault();
        const targetId = link.getAttribute('data-local-florist-grid-target') || baseGridId;
        const isActive = link.classList.contains('is-active');
        if (isActive) {
          clearActive();
          showGrid(baseGridId);
        } else {
          showGrid(targetId);
          setActive(link);
        }
      });
    });
  }

  function setupVariantSliderGridSwap(container, variantId) {
    if (!variantId) return;
    const slider = container.querySelector('[data-local-florist-slider="' + variantId + '"]');
    if (!slider) return;

    const links = slider.querySelectorAll('.utm-collection-slider-link[data-local-florist-grid-target]');
    if (!links.length) return;

    const baseGridId = 'local-florist-grid-' + variantId;

    function clearActive() {
      links.forEach(function (lnk) {
        lnk.classList.remove('is-active');
      });
    }

    function setActive(link) {
      clearActive();
      link.classList.add('is-active');
    }

    function showGrid(targetId) {
      const allGrids = container.querySelectorAll(
        '[data-local-florist-grid="' + variantId + '"][id^="local-florist-grid-' + variantId + '"]'
      );
      allGrids.forEach(function (grid) {
        grid.hidden = grid.id !== targetId;
      });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (evt) {
        evt.preventDefault();
        const targetId = link.getAttribute('data-local-florist-grid-target') || baseGridId;
        const isActive = link.classList.contains('is-active');
        if (isActive) {
          clearActive();
          showGrid(baseGridId);
        } else {
          showGrid(targetId);
          setActive(link);
        }
      });
    });
  }

  function applyIntroBehavior(container, ctx, utmMedium) {
    const introEl = container.querySelector('[data-local-florist-intro]');
    const toggleEls = container.querySelectorAll('[data-local-florist-intro-toggle]');
    if (!introEl) return;

    introEl.hidden = false;

    const mediumList = parseMediumList(ctx && ctx.introHideForMedium);
    const mediumMatch = mediumList.indexOf(normalizeMatch(utmMedium)) !== -1;

    const enabled = mediumMatch ? true : !!(ctx && ctx.introCollapseEnabled);
    if (!enabled || !toggleEls.length) {
      toggleEls.forEach(function (t) {
        t.hidden = true;
      });
      introEl.classList.remove('is-collapsed');
      document.documentElement.classList.remove('lf-intro-collapsed-init');
      document.documentElement.classList.remove('lf-intro-ready');
      return;
    }

    toggleEls.forEach(function (t) {
      t.hidden = false;
    });
    let collapsed = mediumMatch ? true : !!(ctx && ctx.introDefaultClosed);

    function sync() {
      introEl.classList.toggle('is-collapsed', collapsed);
      const i18n = (ctx && ctx.i18n) || {};
      const readMore = i18n.readMore || 'Read more';
      const readLess = i18n.readLess || 'Read less';
      toggleEls.forEach(function (t) {
        t.textContent = collapsed ? readMore : readLess;
        t.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
    }

    sync();
    document.documentElement.classList.add('lf-intro-ready');
    document.documentElement.classList.remove('lf-intro-collapsed-init');
    toggleEls.forEach(function (t) {
      t.addEventListener('click', function () {
        collapsed = !collapsed;
        sync();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('[data-local-florist-root]');
    if (!container) {
      return;
    }

    equalizeTileWidths(container);

    const ctx = safeJsonFromScript('script[type="application/json"][data-local-florist-context]') || {};
    const enableCategorySlider = ctx.enableCategorySlider !== false;
    const enableUtmMatching = ctx.enableUtmMatching !== false;
    const sliderClickBehavior = String(ctx.sliderClickBehavior || 'filter_inline');

    if (enableCategorySlider && sliderClickBehavior === 'filter_inline') {
      setupDefaultSliderGridSwap(container);
    }

    const variants = enableUtmMatching
      ? safeJsonFromScript('script[type="application/json"][data-local-florist-variants]') || []
      : [];
    const utmMedium = getParam('utm_medium').trim();
    applyIntroBehavior(container, ctx, utmMedium);

    if (!enableUtmMatching) {
      document.documentElement.classList.remove('has-utm-adgroup');
      container.style.visibility = '';
      return;
    }

    const utmAdgroupRaw = getParam('utm_adgroup');
    const utmAdgroup = utmAdgroupRaw.trim();
    if (!utmAdgroup) {
      document.documentElement.classList.remove('has-utm-adgroup');
      container.style.visibility = '';
      return;
    }

    const needle = normalizeMatch(utmAdgroup);
    let chosen = null;
    for (let i = 0; i < variants.length; i++) {
      const m = normalizeMatch(variants[i] && variants[i].match_contains);
      if (m && needle.indexOf(m) !== -1 && mediumMatches(variants[i] && variants[i].match_medium, utmMedium)) {
        chosen = variants[i];
        break;
      }
    }

    if (!chosen) {
      document.documentElement.classList.remove('has-utm-adgroup');
      container.style.visibility = '';
      return;
    }

    ctx.adgroup = String(chosen.match_contains || '').trim() || utmAdgroup;

    const titleEl = container.querySelector('[data-local-florist-title]');
    if (titleEl) {
      const t = formatTitle(ctx);
      if (t) titleEl.textContent = t;
    }

    const deliveryTextEl = container.querySelector('[data-local-florist-delivery-text]');
    if (deliveryTextEl) {
      const d = formatDeliveryText(ctx);
      if (d) deliveryTextEl.textContent = d;
    }

    const gridToShow = container.querySelector('[data-local-florist-grid="' + chosen.id + '"]');
    const defaultGrid = container.querySelector('[data-local-florist-grid="default"]');
    const hasVariantGridContent =
      gridToShow && String(gridToShow.textContent || '').trim().length > 0;

    const sliderToShow = enableCategorySlider
      ? container.querySelector('[data-local-florist-slider="' + chosen.id + '"]')
      : null;
    const defaultSlider = enableCategorySlider
      ? container.querySelector('[data-local-florist-slider="default"]')
      : null;
    const hasVariantSliderContent =
      sliderToShow && String(sliderToShow.textContent || '').trim().length > 0;

    const grids = container.querySelectorAll('[data-local-florist-grid]');
    grids.forEach(function (grid) {
      grid.hidden = true;
    });

    if (hasVariantGridContent) {
      gridToShow.hidden = false;
    } else if (defaultGrid) {
      defaultGrid.hidden = false;
    }

    if (enableCategorySlider) {
      const sliders = container.querySelectorAll('[data-local-florist-slider]');
      sliders.forEach(function (slider) {
        slider.hidden = true;
      });

      if (hasVariantSliderContent) {
        sliderToShow.hidden = false;
      } else if (defaultSlider && ctx.showDefaultSlider !== false) {
        defaultSlider.hidden = false;
      }

      equalizeTileWidths(container);

      if (sliderClickBehavior === 'filter_inline') {
        setupVariantSliderGridSwap(container, chosen.id);
      }
    }

    document.documentElement.classList.remove('has-utm-adgroup');
    container.style.visibility = '';
  });
})();
